import {BookmarkButton} from '../components/bookmarkButton.js';

/**
 * Bookmarks behavior - scans the page for bookmark buttons and initializes them.
 * This behavior enhances all elements with the `.js-bookmarkButton` class.
 */

/**
 * Initialize all bookmark buttons on the page.
 * @param {Document|HTMLElement} container Scope to search for bookmark buttons
 */
export function initBookmarks(container = document) {
    const scope = container instanceof HTMLElement ? container : document;
    const bookmarkButtons = scope.querySelectorAll('.js-bookmarkButton');

    bookmarkButtons.forEach((buttonElement) => {
        if (buttonElement.dataset.bookmarkInitialized === 'true') {
            return;
        }

        new BookmarkButton(buttonElement);
        buttonElement.dataset.bookmarkInitialized = 'true';
    });
}

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => initBookmarks()) : initBookmarks();

document.addEventListener('htmx:afterSwap', (event) => {
    initBookmarks(/** @type {HTMLElement} */ (event.target));
});
